<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { onMounted, ref, watch } from "vue";
import { PurchasedProduct, Trainer } from "../../types/PersologOnlineTypes.ts";
import { ProfileAdministrationAPI } from "../../api";

const { t } = useI18n();

const props = defineProps({
    visibleToggle: {
        type: Boolean,
        default: false
    },
    account: {
        type: Object as () => Trainer,
        required: true
    },
    texts: {
        type: Object as () => Record<string, string>,
        required: true
    }
});

const visible = ref(props.visibleToggle);
const stock = ref<PurchasedProduct[]>([]);

const emit = defineEmits(["update:visible"]);

watch(
    () => visible.value,
    () => {
        emit("update:visible", visible.value);
    }
);

watch(
    () => props.visibleToggle,
    () => {
        visible.value = props.visibleToggle;
    }
);

async function fetchStock(trainer: Trainer) {
    stock.value = (await ProfileAdministrationAPI.fetchPurchasedProducts(trainer.id)).map(
        (purchase) => ({
            product: props.texts[purchase.product] ? `${props.texts[purchase.product]} (${purchase.product.toUpperCase()})` : purchase.product.toUpperCase(),
            quantity: purchase.quantity,
            id: purchase.id,
            trainer: purchase.trainer
        })
    );
}

onMounted(async () => {
    await fetchStock(props.account);
});
</script>
<template>
    <Toast />
    <Dialog
        id="stock-dialog_dialog_stock"
        v-model:visible="visible"
        modal
        :header="t('header.accountSettings.purchases') + ' - ' + props.account?.firstname + ' ' + props.account?.lastname"
        position="center"
        :style="{ minWidth: '40vw', maxWidth: '50vw' }"
        :dismissable-mask="false"
        :block-scroll="true"
        :draggable="false"
    >
        <DataTable id="stock-dialog_table_stock" :value="stock" striped-rows scroll-height="50vw">
            <Column field="product" :header="t('header.accountSettings.transactionTable.product')" />
            <Column field="quantity" :header="t('common.profiles.quantity')" />
        </DataTable>
    </Dialog>
</template>
